import OurFeesCompensationTable from "modules/storyblok/components/OurFeesCompensationTable";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { OurFeesCompensationTableAdapterProps } from "./OurFeesCompensationTable.d";

const OurFeesCompensationTableAdapter = ({
  blok,
  sbEditable,
}: ReactStoryblokComponent<OurFeesCompensationTableAdapterProps>) => (
  <OurFeesCompensationTable blok={blok} sbEditable={sbEditable} />
);

export default OurFeesCompensationTableAdapter;
